import BadgeIcon from "../../../Icons/BadgeIcon";
import { useToast } from "../../../hooks/ToastContext";
import { useParams } from "react-router-dom";
function ViralShare({
  entryjson,
  inputs,
  setInputs,
  saveMemberEntry,
  contest_id,
  purl,
  ffrefurl,
  contestDetails,
}) {
  // const { showToast } = useToast();
  const { cid } = useParams();
  
  const session_member = sessionStorage.getItem("member_" + contest_id);
  let member_det = JSON.parse(session_member);
  const entrydet = JSON.parse(entryjson.entry);
  let vshare_url;
  if (ffrefurl !== "" && ffrefurl !== null && typeof ffrefurl !== "undefined") {
    vshare_url = ffrefurl + "?mid=" + member_det?.url_token;
  } else if (
    contestDetails.published_url !== "" &&
    contestDetails.published_url !== "" &&
    contestDetails.published_url !== null &&
    typeof contestDetails.published_url !== "undefined"
  ) {
    vshare_url =
      contestDetails?.published_url + "?mid=" + member_det?.url_token;
  } else if (purl !== "" && purl !== null && typeof purl !== "undefined") {
    vshare_url = purl + "?mid=" + member_det?.url_token;
  } else {
    //vshare_url = config.VIRAL_SHARE_URL + "/" + contest_id + "/" + member_det?.url_token;
    // vshare_url = `${window.location.origin}/${contest_id}?mid=${member_det?.url_token}`;

      if(cid == null){
            vshare_url = `${window.location.origin}?mid=${member_det?.url_token}`;
      }else{
          vshare_url = `${window.location.origin}/${contest_id}?mid=${member_det?.url_token}`;
      }
  }

  const { showToast } = useToast();

  // const handleChange = e => {

  //     setInputs(inputs => {
  //         return {
  //             ...inputs,
  //             [e.target.name]: e.target.value
  //         }
  //     });

  // };

  // const saveEntry = () => {
  //   saveMemberEntry();
  // };

  const copyText = () => {
    const textarea = document.createElement("textarea");
    textarea.value = vshare_url;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
    showToast("success", "URL Copied");
  };

  const replacementValue = entrydet?.worth || ""; // Ensure it's a string
  const updatedText = (entrydet?.default_note_text || "").replace(
    /\[points\]/g,
    replacementValue
  );
  return (
    <div className="cursor-default">
      <div className="flex flex-col md:flex-row justify-between">
        <div className="md:w-[440px]">
          <h4 className="font-medium text-[15px] leading-[22px] text-black opacity-100 mb-1">
            {entrydet?.headline}
          </h4>
          <p className="text-left font-normal text-[14px] leading-[20px] text-black opacity-100 sm:text-[12px] sm:leading-[20px] mb-1">
            {entrydet?.default_share_text}
          </p>
          <p className="text-left font-normal text-[14px] leading-[20px] text-black opacity-100 sm:text-[12px] sm:leading-[20px] mb-1">
            {updatedText}
          </p>
        </div>
        <div className="hidden min-[426px]:block">
          <span class="earn_points_btn bg-white text-[#0274F7] text-sm font-medium inline-flex items-center px-3 py-1 rounded-md border border-[#0274F7]">
            <BadgeIcon width={20} height={20} className={"mr-1"} />
            {entrydet?.worth} <span className="text-sm ml-1">Points</span>
          </span>
        </div>
      </div>
      <div className="">
        <div className="mt-2">
          {/* <input type="text" name="entry_val" readOnly id="entry_val" onChange={handleChange} value={vshare_url} className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-500 sm:text-sm sm:leading-6" autoComplete="off" /> */}
          {/* <div className="primary_light_bgcolor bg-[#E1EDF9] p-4 mt-2 rounded-md w-full"> */}
          <div className="w-full p-2">
            {/* <div className="mb-2 flex justify-between items-center">
                                <label htmlFor="website-url" className="text-sm font-medium text-gray-900">
                                    Contest URL
                                </label>
                            </div> */}
            <div className="flex flex-col sm:flex-row items-stretch relative w-full gap-2 sm:gap-0">
              <input
                id="website-url"
                type="text"
                className="bg-gray-50 border border-gray-300 text-gray-500 text-sm w-full p-2 rounded-md sm:rounded-l-md sm:rounded-r-none"
                readOnly
                disabled
                value={vshare_url}
              />
              <button
                onClick={copyText}
                className="primary_btn_bg shrink-0 inline-flex items-center justify-center py-2 px-4 text-sm font-medium text-white bg-[#0274F7] rounded-md sm:rounded-r-lg sm:rounded-l-none hover:bg-white hover:text-[#0274F7] border border-[#0274F7] hover:border-[#0274F7] w-full sm:w-auto"
                type="button"
              >
                Copy Link
              </button>
            </div>
          </div>
          {/* </div> */}
        </div>
      </div>
      <div className="flex items-center justify-between">
        {/* <div className="pt-2">
          <button
            onClick={() => saveEntry()}
            className={`primary_btn_bg bg-[#0274F7] text-white px-3 py-2 rounded-md text-[13px] leading-[15px] border border-[#0274F7] hover:bg-white hover:text-[#0274F7] hover:border-[#0274F7]`}
          >
            Next Goal
          </button>
        </div> */}
        <div className="pt-2">
          <span class="earn_points_btn bg-white ml-2 text-[#0274F7] text-sm font-medium inline-flex items-center px-3 max-[325px]:px-1 py-1 rounded-md border border-[#0274F7] sm:hidden">
            <BadgeIcon width={20} height={20} className={"mr-1"} />
            {entrydet?.worth} <span className="text-sm ml-1">Points</span>
          </span>
        </div>
      </div>
    </div>
  );
}

export default ViralShare;
